import { type ItemFragmentFragment } from '@apps/www/src/__generated__/graphql';
import useViewportName from '@apps/www/src/www/hooks/useViewportName';
import SVGrid from '@pkgs/shared-client/components/SVGrid';
import SVGridItem from '@pkgs/shared-client/components/SVGridItem';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import { unit } from '@pkgs/shared-client/styles/mixins';
import { VIEWPORTS, type GridColumnsConfigID } from '@pkgs/shared/constants';
import clsx from 'clsx';

// TODO: Only load image if visible. Use useIntersection from nextjs?

type Props = {
	items: ItemFragmentFragment[];
};

const SVLandingGrid = ({ items }: Props) => {
	const viewportName = useViewportName();

	const handleGetColumnClassName = useEventCallback((columnIndex: number) => {
		return clsx(
			'landing-column',
			columnIndex % 2 === 0 ? 'animate-sliding-up' : 'animate-sliding-down',
		);
	});

	const handleGetColumnStyle = useEventCallback((columnIndex: number) => {
		return {
			animationDelay: unit(columnIndex * 0.15, 's'),
			// animationDelay: unit(Math.random() * 1.5, 's'),
		};
	});

	const viewportConfig = viewportName && VIEWPORTS[viewportName];
	const columnsConfigID = (viewportConfig?.columns || 8) as GridColumnsConfigID;
	const spacingConfigID = 8;

	return (
		<div className="bg-background pointer-events-none fixed inset-0 h-full w-full overflow-hidden">
			{/* columnsConfigID can be undefined if viewportName is not ready yet (on server and client first render) */}
			{columnsConfigID ? (
				<SVGrid
					className="scale-125"
					autoPlayGIFs={false}
					columnsConfigID={columnsConfigID}
					isStatic={true}
					items={items}
					keyExtractor={(item) => item._id}
					spacingConfigID={spacingConfigID}
					getColumnClassName={handleGetColumnClassName}
					getColumnStyle={handleGetColumnStyle}
					renderItem={(item, props) => (
						<SVGridItem
							{...SVGridItem.itemToProps(item)}
							{...props}
							forceThumbnail={true}
						/>
					)}
				/>
			) : null}
			<div className="bg-background absolute top-0 h-full w-full bg-opacity-75" />
		</div>
	);
};

export default SVLandingGrid;
